var React = require('react');

function WarningIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.5859 10.8359L7.96094 1.06247C7.53906 0.335911 6.4375 0.312474 6.01563 1.06247L0.390627 10.8359C-0.0312479 11.5625 0.507815 12.5 1.375 12.5H12.6016C13.4688 12.5 14.0078 11.5859 13.5859 10.8359ZM7 8.79685C7.58594 8.79685 8.07813 9.28904 8.07813 9.87497C8.07813 10.4843 7.58594 10.9531 7 10.9531C6.39063 10.9531 5.92188 10.4843 5.92188 9.87497C5.92188 9.28904 6.39063 8.79685 7 8.79685ZM5.96875 4.92966C5.94531 4.7656 6.08594 4.62497 6.25 4.62497H7.72656C7.89063 4.62497 8.03125 4.7656 8.00781 4.92966L7.84375 8.11716C7.82031 8.28122 7.70313 8.37497 7.5625 8.37497H6.41406C6.27344 8.37497 6.15625 8.28122 6.13281 8.11716L5.96875 4.92966Z"}));
}

WarningIconInline.defaultProps = {"width":"14","height":"13","viewBox":"0 0 14 13","fill":"none"};

module.exports = WarningIconInline;

WarningIconInline.default = WarningIconInline;
